import { useDroppable } from '@dnd-kit/core';
import { Box, Typography, useTheme } from '@mui/material';
import { CustomTheme } from '../../contexts/theme.context';

export const DroppableContainer = ({
  id,
  children,
  isEmpty,
}: {
  id: string;
  children: React.ReactNode;
  isEmpty: boolean;
}) => {
  const theme = useTheme<CustomTheme>();
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        paddingLeft: 4,
        minHeight: isEmpty ? 150 : 60,
        backgroundColor: isOver ? '#e3f2fd' : 'white',
        borderRadius: 1,
        padding: 2,
        flex: 1,
        border: isOver ? `2px dashed ${theme.palette.primary.main}` : 'none',
        position: 'relative',
        transition: 'all 0.2s ease',
        ...(isEmpty && {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }),
      }}
    >
      {isEmpty ? (
        <Typography variant="body2">
          Drop items here, click &quot;Add&quot; or &quot;Add Expression&quot; to get started.
        </Typography>
      ) : (
        children
      )}
    </Box>
  );
};
